/**
 * @param {number} ms
 */
export function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/**
 * @template T
 * @param {() => Promise<T>} fn
 * @param {{
 *   retries?: number,
 *   delayMs?: number,
 *   shouldAbort?: () => boolean,
 *   onRetry?: (attempt: number, err: unknown) => void,
 * }} [options]
 * @returns {Promise<T>}
 */
export async function fetchWithRetry(fn, options = {}) {
  const retries = options.retries ?? 2;
  const delayMs = options.delayMs ?? 400;
  let lastErr;

  for (let attempt = 0; attempt <= retries; attempt += 1) {
    if (options.shouldAbort?.()) {
      throw lastErr ?? new Error('fetchWithRetry aborted');
    }
    try {
      return await fn();
    } catch (err) {
      lastErr = err;
      if (attempt < retries) {
        options.onRetry?.(attempt + 1, err);
        await sleep(delayMs * (attempt + 1));
      }
    }
  }

  throw lastErr;
}
